import { Navigate } from "react-router-dom";
import AuthService from "./auth/authService";

const PrivateRoute = ({ children }) => {
  return AuthService.isAuthenticated() ? children : <Navigate to="/login" />;
};

export default PrivateRoute;
